module.exports = __webpack_public_path__ + "res/puzzle_slide.eaaca38b735fd9ae2dff3a9060a90d3c.webp";